import { MatxLoadable } from "matx";
import { isMdScreen } from "utils";

const Menu = MatxLoadable({
  loader: () => import("./tables/adminMenuTable")
});

const Calendar = MatxLoadable({
  loader: () => import("./tables/adminCalendarTable")
});

const Contacts = MatxLoadable({
  loader: () => import("./tables/adminContactsTable")
});

const Kudos = MatxLoadable({
  loader: () => import("./tables/adminKudosTable")
});

const Banners = MatxLoadable({
  loader: () => import("./forms/bannersSettings")
});

const AskAlejandro = MatxLoadable({
  loader: () => import("./forms/askAlejandroSettings")
});

const Chatbot = MatxLoadable({
  loader: () => import("./forms/chatbotSettings")
});

const MenuForm = MatxLoadable({
  loader: () => import("./forms/FormAdminMenu")
});

const CalendarForm = MatxLoadable({
  loader: () => import("./forms/FormAdminCalendar")
});

const ContactsForm = MatxLoadable({
  loader: () => import("./forms/FormAdminContacts")
});

const VideoForm = MatxLoadable({
  loader: () => import("./forms/videoSettingsForm")
});

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: true
    },
    leftSidebar: {
      show: true,
      mode: isMdScreen() ? "close" : "full"
    }
  },
  likeDislikeButtons: { show: false }
};

const menuRoutes = [
  {
    path: "/Menu/Settings",
    component: Menu,
    settings
  },
  {
    path: "/Video/Settings",
    component: VideoForm,
    settings
  },
  {
    path: "/Banners/Settings",
    component: Banners,
    settings
  },
  {
    path: "/AskAlejandro/Settings",
    component: AskAlejandro,
    settings
  },
  {
    path: "/Chatbot/Settings",
    component: Chatbot,
    settings
  },
  {
    path: "/Kudos/Settings",
    component: Kudos,
    settings
  },
  {
    path: "/Calendar/Settings",
    component: Calendar,
    settings
  },
  {
    path: "/Contact/Settings",
    component: Contacts,
    settings
  },
  {
    path: "/Menu/MenuForm/:id",
    component: MenuForm,
    settings
  },
  {
    path: "/Menu/MenuForm",
    component: MenuForm,
    settings
  },
  {
    path: "/Calendar/CalendarForm/:id",
    component: CalendarForm,
    settings
  },
  {
    path: "/Calendar/CalendarForm",
    component: CalendarForm,
    settings
  },
  {
    path: "/Contact/ContactForm/:id",
    component: ContactsForm,
    settings
  },
  {
    path: "/Contact/ContactForm",
    component: ContactsForm,
    settings
  },
];

export default menuRoutes;
